import { observer } from "mobx-react-lite";
import { PopupProps } from "react-map-gl";
import useFitBounds from "../hooks/useFitBounds";
import { InitiatorType } from "../hooks/useFlyTo";
import Shape from "../interfaces/Shape";
import MapPopup from "./MapPopup";

interface MapPopupWithFitBoundsProps extends PopupProps {
    shape: Shape
};

function MapPopupWithFitBounds({ children, shape, ...props }: MapPopupWithFitBoundsProps) {
    useFitBounds(shape, InitiatorType.Popup);

    return (
        <MapPopup {...props} >
            {children}
        </MapPopup>
    );
}

export default observer(MapPopupWithFitBounds);